import apiClient from './apiClient';

export interface Scholarship {
  id: string;
  academy_id: string;
  name: string;
  percentage: number;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

const DEFAULT_ACADEMY_SLUG = 'btalentstar';

export const scholarshipApiService = {
  async getPublicScholarships(academySlug?: string): Promise<Scholarship[]> {
    const slug = academySlug || DEFAULT_ACADEMY_SLUG;
    const { data } = await apiClient.get<Scholarship[]>(
      `/scholarships/public/${slug}`,
      { skipAuth: true }
    );
    return data;
  },
};

export default scholarshipApiService;
